import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import JobCardsImage from "@/assets/images/jobCards.png";
import { Typography } from "@/components/ui/typography";
import useScreens from "@/hooks/useScreens";
import { cn } from "@/lib/utils";
import useAuthStore from "@/store/useAuthStore";

type AuthWrapperProps = PropsWithChildren<{
  className?: string;
  withRightBlock?: boolean;
}>;
export default function AuthWrapper({ children, className, withRightBlock }: AuthWrapperProps) {
  const { isAuthorized } = useAuthStore();
  const isTabletOrMore = useScreens("md", "up");

  if (isAuthorized) {
    return <Navigate to="/jobs" />;
  }

  return (
    <div className={cn("flex min-h-screen", className)}>
      <div
        className={cn(
          "flex flex-1 flex-col items-center self-center",
          !withRightBlock && "bg-[url('assets/images/pattern-squares.png')] bg-contain bg-top bg-no-repeat"
        )}
      >
        {children}
      </div>
      {withRightBlock && isTabletOrMore && (
        <div className="from-primary-300 to-primary-600 m-2 flex flex-1 flex-col justify-center rounded-md bg-linear-to-bl">
          <img
            src={JobCardsImage}
            width="80%"
            height={420}
            className="self-center"
            alt="jobs list and job details preview"
          />
          <div className="max-w-[456px] self-center">
            <Typography variant="display-xs" weight="semibold" className="text-center text-white">
              Professional Engineering at your fingertips
            </Typography>
            <Typography variant="text-md" className="mb-20 text-center text-violet-200">
              Speed up your delivery time with this powerful engineering software. Serve your customers like never
              before with full calculation packages in seconds.
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
}
